import React, { useState, useEffect } from "react";

import {
    Box, 
    Divider,
    Grid,
    Typography,
    Button,
    styled,
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableFooter
} from '@mui/material';

import { useNavigate, useParams } from "react-router-dom";

import { useDocuments, documentTypes, targetTypes } from "../../../../hooks/api/useDocuments";
import { useSystemPrompt } from "../../../../hooks/useSystemPrompt";
import { useSystemUtils } from "../../../../hooks/useSystemUtils";
import { useAppContextFeatures } from "../../../../context/AppContext";
import { useSystemRoutes, routeTypes } from "../../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../../hooks/useSystemHead';

import CommonSectionHeader from "../../../../components/common/CommonSectionHeader";
import CommonBreadcumbs from "../../../../components/common/CommonBreadcumbs";
import { CommonPdf, renderModes, documentTypes as commonPdfDocumentTypes } from "../../../../components/common/CommonPdf";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem'
}))

const StyledContent2 = styled(Typography)(({ theme }) => ({
    fontSize: '0.8rem',
    mt: 2
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1, 
    mb: 0,
    borderStyle: 'dashed'
}))

export default function PackingOrderViewPage() {

    const { id } = useParams();

    const { setSystemLoading, openCustomDrawer } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { get } = useDocuments({ documentType: documentTypes.packingOrder, targetType: targetTypes.packingOrder });
    const { formatCurrencyDisplay, currencyAbb } = useSystemUtils();
    const { getRoute } = useSystemRoutes(routeTypes.admin)
    const { getHtmlHead } = useSystemHead(routeTypes.admin)

    const navigate = useNavigate();
    const [ data, setData ] = useState()

    const fetchData = async () => {

        setSystemLoading(true);

        try{

            let response = await get({ id });
            // console.log('response?.data?.items', response?.data)
            setData(response?.data)

        }catch(error){
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    useEffect(() => {

        fetchData();

    }, [])

    const RenderTable = () => {

        if(!data) return <></>

        return (
            <TableContainer 
                // component={Paper}
                sx={{
                    minHeight: 400,
                    maxHeight: 400
                }}
            >
                <Table 
                    size="small"
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            <TableCell width={20}>#</TableCell>
                            <TableCell width={180}>Document No.</TableCell>
                            <TableCell width={200}>Document Date</TableCell>
                            <TableCell width={300}>Remark</TableCell>
                            {/* <TableCell align="center">Packing Status</TableCell>
                            <TableCell align="center">Packing date</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {
                            data?.docs.map((row, index) => {

                                return (
                                    <TableRow key={row.id}>
                                        <TableCell>{(index+1)}</TableCell>
                                        <TableCell>{row.doc_number}</TableCell>
                                        <TableCell>{row.doc_date}</TableCell>
                                        <TableCell align="left">{row.doc_remark}</TableCell>
                                        {/* <TableCell align="center">{row.is_create_packing_order_status ==="1"? "Packed" : "Not yet pack"}</TableCell>
                                        <TableCell align="center">{row.is_create_packing_order_date}</TableCell> */}
                                    </TableRow>
                                )
                            })

                    }
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    const RenderFormProfile = () => {

        const {
            document
        } = data

        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                        
                        <CommonSectionHeader
                            title={`Profiles`}
                            subTitle={`Related profiles attached to document`}
                        />                     
                        
                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>
                    
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2}}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Location</StyledLabel>
                            </Grid>

                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {document?.location_name}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                        
                        <CommonSectionHeader
                            title={`Document`}
                            subTitle={`Basic information about the document`}
                        />                            
                        
                    </Grid>
                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2}}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Document No.</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_number}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Document Date</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_date}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>
                                     Remark
                                </StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_remark}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        if(!data) return <></>

        return(
            <>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={5} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>
                    <Grid item xs={12} sm={12} md={7} textAlign={"left"}>
                        {
                            RenderFormProfile()
                        }
                    </Grid>
                </Grid>
                
                <Box
                    sx={{
                        textAlign: 'left',
                        mt: 3,
                        pl: 0.5,
                    }}
                >
                    <CommonSectionHeader
                        title={`Items`}
                        subTitle={`Detail information about the items involved`}
                    />
                </Box>
                
                <StyledCard
                    sx={{
                        mt: 1.5,
                        p: 0
                    }}
                >
                    <Grid container rowSpacing={0}>
                        <Grid item md={12}>
                            <RenderTable />
                        </Grid>
                        {/* <Grid item md={12}>
                            <RenderTableFooter />
                        </Grid> */}

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2}}>
                    <Grid item md={12} textAlign={"center"}>
                        <Button
                            type="button"
                            variant="contained"
                            sx={{ 
                                mt: 3,
                                mb: 2
                            }}
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </Button>
                    </Grid>
                </Grid>
            </>
        )
    }

    return (
        <Box>
            {  
                getHtmlHead({ routeType: routeTypes.admin, title: headTitles.viewPackingOrder })
            }

            <CommonBreadcumbs
                routeType={routeTypes.admin}
                pageTitle={`Packing Order ${data?.document.doc_number}`}
                actionMenus={[
                    // {
                    //     displayText: "Edit",
                        // onClick: () => {
                        //     navigate(getRoute(`documents/packingOrder/update/${id}`))
                        // }
                    // },
                    // {
                    //     displayText: "Print Preview",
                    //     onClick: () => {
                            
                    //         openCustomDrawer({ 
                    //             show: true, 
                    //             anchor: "right",
                    //             title: `Preview PDF`,
                    //             PaperProps: {
                    //                 sx: { width: 2/3 }
                    //             },
                    //             // handleOnClose: () => setPreviewPdfOpen(false),
                    //             ComponentActions: <></>,
                    //             ComponentBody: 
                    //                 <CommonPdf
                    //                     routeType={routeTypes.admin}
                    //                     renderMode={renderModes.preview.id}
                    //                     documentType={commonPdfDocumentTypes.itemRelocate.id}
                    //                     document={{
                    //                         title: data?.document?.doc_number
                    //                     }}
                    //                     data={data}
                    //                     // customData={{
                    //                     //     items: data
                    //                     // }}
                    //                 />
                    //         })

                    //         return true;

                    //     }
                    // }
                ]}
                breadcrumbs={[
                    {
                        displayText: "Packing Orders",
                        props: {
                            href: getRoute("documents/packingOrders")
                        }
                    },
                    {
                        displayText: `#${data?.document.doc_number}`,
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            { RenderForm() }

        </Box>
    )
}